// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__iyyJI","sub_container":"WordGameLayout_sub_container__0gbP6"};